import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(3),

      '& > * + *': {
        marginTop: theme.spacing(0.5),
      },
    },
    brandsName: {
      color: theme.palette.grey[500],
    },
  }),
);
